"use strict";

let KDApplyVariants: Record<string, ApplyVariant> = {
	"AntiMagic": {
		minfloor: 0,
		//maxfloor: 0,
		prefix: "AntiMagic",
		level: 1,
		powerBonus: 1,
		hexes: ["AntiMagic"],
		enchants: [],
	},
};
